import { render, staticRenderFns } from "./UserLevel.vue?vue&type=template&id=40132c1e&"
import script from "./UserLevel.vue?vue&type=script&lang=js&"
export * from "./UserLevel.vue?vue&type=script&lang=js&"
import style0 from "./UserLevel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40132c1e')) {
      api.createRecord('40132c1e', component.options)
    } else {
      api.reload('40132c1e', component.options)
    }
    module.hot.accept("./UserLevel.vue?vue&type=template&id=40132c1e&", function () {
      api.rerender('40132c1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UserLevel.vue"
export default component.exports